module.exports = __webpack_public_path__ + "static/media/QuarterView.e5241fb4.svg";